module.exports = "https://cdn.thelire.com/ins/resource/lh_store_vip_ok.0c962dea333a8ba3fe8ecc509aa27672.png";